import React from 'react';
var Azion = function Azion() {
  return React.createElement("script", {
    defer: true,
    fetchpriority: "low",
    src: "https://wx.mlcdn.com.br/shared/azion/azfp-63fe5.min.js"
  });
};
Azion.ssr = true;
export default Azion;